import React, { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import { Button } from 'primereact/button';
import Pagamento from '../pagamento';
import apiBack from '../../services/backAxios';
import './styles.css';
import DialogSuccessPagamentoCartao from '../dialogs/dialog-pagamento-cartao';

const CobrarAdesao = (props) => {
    const { tipoCobranca, mensalidade, valorAdesao, dadosRecorrencia, associado } =
        props;
    const [dataBaixaAdesao, setDataBaixaAdesao] = useState();

    const [openPopup, setOpenPopup] = useState(true);

    const [openDialogSuccessPayment, setOpenDialogSuccessPayment] = useState(false);

    useEffect(() => {
        (async () => {
            const { data } = await apiBack.get(
                `contratoEletronico/checaBaixaAdesao/${associado.Inscricao}`
            );
            setDataBaixaAdesao(data);
        })();

    }, []);

    let nomeBotaoAdesao;

    let ativarRecorrencia = false;

    if (tipoCobranca === 7 && !dadosRecorrencia && dataBaixaAdesao) {
        nomeBotaoAdesao = ' Ativar Recorrência ';
        ativarRecorrencia = true;
    } else if (tipoCobranca === 1 || 8) {
        nomeBotaoAdesao = 'Cobrar Adesão';
    } else if (tipoCobranca === 7) {
        nomeBotaoAdesao = 'Cobrar Adesão + Recorrência';
    }

    return (
        <>
            <div style={!openPopup ? { display: 'none' } : {}}>
                {openPopup && (
                    <Popup
                        contentStyle={{ width: '90%' }}
                        modal
                        trigger={
                            <button
                                type="submit"
                                icon="pi pi-plus"
                                iconPos="left"
                                className="btn-primary"
                            >
                                {nomeBotaoAdesao}
                            </button>
                        }
                    >
                        {(close) => (
                            <>
                                <Pagamento
                                    inscricao={props.inscricao}
                                    associado={props.associado}
                                    adesao={valorAdesao}
                                    mensalidade={mensalidade}
                                    tipoCobranca={tipoCobranca}
                                    ativarRecorrencia={ativarRecorrencia}
                                    fecharPopup={setOpenPopup}
                                    setOpenDialogSuccessPayment={
                                        setOpenDialogSuccessPayment
                                    }
                                />
                                <Button type="button" label="Fechar" onClick={close} />
                            </>
                        )}
                    </Popup>
                )}
            </div>
            <DialogSuccessPagamentoCartao
                openDialog={openDialogSuccessPayment}
                setOpenDialog={setOpenDialogSuccessPayment}
            />
        </>
    );
};

export default CobrarAdesao;

